import { msg } from "@lingui/core/macro";

export const vehiclePlateCharacterLengthRuleMessages = {
	name: msg({ message: "Plate Length" }),
	description: msg({ message: "The maximum number of characters a license plate may contain" }),
	errors: {
		incorrectLength: msg({
			message:
				"Vehicle Plate character count must be between or equal to {minLength} and {maxLength} characters.",
		}),
	},
} as const;
